import React, { useState } from 'react';
import Background from "../../../assets/images/background/banner.jpg";
import { Link } from 'react-router-dom';

import Arrow from "../../../assets/images/Services/right-arrow.png";
import { FaCheckCircle } from "react-icons/fa";


import img1 from "../../../assets/images/Product/Lead Managemnet/image1.png";
import img2 from "../../../assets/images/Product/Lead Managemnet/image2.png";
import img3 from "../../../assets/images/Product/Lead Managemnet/image3.png";
import img4 from "../../../assets/images/Product/Lead Managemnet/image4.png";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import SEO from '../../seo';

export default function Lead() {
    const [openImageIndex, setOpenImageIndex] = useState(null);

    const images = [img1, img2, img3, img4];

    const pageKeywords = [
        "react website",
        "static pages",
        "web development",
        "SEO services"
    ];


    return (
        <div>
            <SEO
                title="Lead Management"
                description="At HWPL! we recognize that privacy is important. This Privacy Policy applies to all products and services provided by us. Collection Of Information Disclaimer: Please read and edit the Privacy Policy given below as per your /website’s requirement. Don’t use or apply these as is basis on your website. We collect various information when you [&hellip;]"
                canonical="https://www.hwplindia.com/products/lead-management/"
                ogImage="https://www.hwplindia.com/wp-content/uploads/2024/01/erp-crm-development-company-banner-img.png"
                keywords={pageKeywords}
            />
            <section
                className="page-title"
                style={{ backgroundImage: `url(${Background})` }}
            >
                <div className="auto-container">
                    <h2>Lead Management</h2>
                    <ul className="bread-crumb clearfix">
                        <li>
                            <Link to="/">Home</Link>
                        </li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li>
                            <Link to="/products">Products</Link>
                        </li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li>Lead Management</li>
                    </ul>
                </div>
            </section>
            <section className="branding-section1">
                <div className="at-container">

                    {/* Content Section */}
                    <div className="branding-content">
                        {/* CTA */}
                        <section className="cta-section attendance-h3">
                            <h3 className=''>“Lead Management System with TradeIndia & IndiaMART Integration”</h3>
                            <p>
                                At Horizon Webinfo Pvt. Ltd. we empower businesses to convert more inquiries into customers through intelligent automation. Our Lead Management System centralizes, organizes, and optimizes every lead — ensuring fast response, improved follow-ups, and higher conversions.
                            </p>
                            <h3 className='cta-section-business-process it-consult attendance-consult'>Why a Smart Lead Management System?</h3>
                        </section>


                        {/* Sections */}
                        <section className='it-consult simple-section'>
                            <section className="branding-item">
                                <h4><img src={Arrow} />
                                    Seamless Integration with IndiaMART & TradeIndia</h4>
                                <p>
                                    Your leads flow into one unified platform automatically. No manual downloads, no missed opportunities — every inquiry is captured in real time.                                </p>
                            </section>

                            <section className="branding-item">
                                <h4><img src={Arrow} />
                                    Automated Lead Tracking for Higher Conversions</h4>
                                <p>
                                    From allocation to follow-ups, reminders, and performance insights, the system ensures every lead receives timely attention. Faster responses mean better customer relationships and more sales.
                                </p>
                            </section>

                            {/* Our Expertise in Attendance */}
                            <section className="cta-section">
                                <h3 className='cta-section-business-process attendance-expert'>Our Expertise in Lead Management Technology</h3>
                            </section>
                            <section className='simple-section attaaa'>

                                <section className="attendance-li">
                                    <h4>
                                        Real-Time Lead Automation</h4>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Direct integration with IndiaMART & TradeIndia</li></p>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Auto-fetching of leads with full inquiry details</li></p>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Duplicate lead prevention & intelligent grouping</li></p>
                                </section>

                                <section className="attendance-li">
                                    <h4>
                                        Sales Team Management</h4>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Automatic or manual lead allocation</li></p>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Follow-up reminders, notes, and call tracking</li></p>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Activity timeline for complete lead history</li></p>
                                </section>

                                <section className="attendance-li">
                                    <h4>
                                        Smart Communication Tools</h4>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> WhatsApp messaging directly from the system</li></p>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Email communication with templates</li></p>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Quick replies for faster customer engagement</li></p>
                                </section>

                                <section className="attendance-li">
                                    <h4>
                                        Powerful Analytics & Reports</h4>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Sales performance dashboards</li></p>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Lead source analysis</li></p>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Conversion ratio & productivity insights</li></p>
                                </section>
                            </section>


                            <div className='image-swip'>
                                <Swiper
                                    modules={[Navigation, Pagination, Autoplay]}
                                    slidesPerView={3}          // show 2 images at a time
                                    spaceBetween={30}
                                    slidesPerGroup={1}         // slide one by one
                                    navigation={false}
                                    pagination={{ clickable: true, dynamicBullets: false }}
                                    autoplay={{
                                        delay: 2500,
                                        disableOnInteraction: false,
                                    }}
                                    loop={true}
                                    breakpoints={{
                                        // Mobile
                                        0: {
                                            slidesPerView: 1,
                                        },

                                        // Small devices (landscape phones)
                                        576: {
                                            slidesPerView: 2,
                                        },

                                        // Tablets
                                        1015: {
                                            slidesPerView: 3,
                                        },

                                        // Desktop
                                        1330: {
                                            slidesPerView: 3,
                                        },
                                    }}
                                    className="branding-swiper lead-swiper"
                                >

                                    <SwiperSlide onClick={() => setOpenImageIndex(0)}>
                                        <img src={img1} className="attendance-img lead" />
                                    </SwiperSlide>

                                    <SwiperSlide onClick={() => setOpenImageIndex(1)}>
                                        <img src={img2} className="attendance-img lead" />
                                    </SwiperSlide>

                                    <SwiperSlide onClick={() => setOpenImageIndex(2)}>
                                        <img src={img3} className="attendance-img lead" />
                                    </SwiperSlide>

                                    <SwiperSlide onClick={() => setOpenImageIndex(3)}>
                                        <img src={img4} className="attendance-img lead" />
                                    </SwiperSlide>

                                </Swiper>
                                {openImageIndex !== null && (
                                    <div className="image-popup">

                                        <div className="close-btn" onClick={() => setOpenImageIndex(null)}>
                                            ✕
                                        </div>

                                        <div className="popup-img-wrapper">

                                            <button
                                                className="popup-swiper-arrow left"
                                                onClick={() =>
                                                    setOpenImageIndex(
                                                        (openImageIndex - 1 + images.length) % images.length
                                                    )
                                                }
                                            >
                                                ❮
                                            </button>

                                            <img
                                                src={images[openImageIndex]}
                                                alt="preview"
                                                className="popup-big-img"
                                            />

                                            <button
                                                className="popup-swiper-arrow right"
                                                onClick={() =>
                                                    setOpenImageIndex((openImageIndex + 1) % images.length)
                                                }
                                            >
                                                ❯
                                            </button>

                                        </div>

                                    </div>
                                )}

                            </div>


                            {/* Why This Helps Your Business */}

                            <section className="cta-section simple-section1">
                                <h3 className='cta-section-business-process attendance-expert why-lead'>Why This Helps Your Business</h3>
                            </section>

                            <section className="simple-section">
                                <div className="item">
                                    <div className="num"><img src={Arrow} /></div>
                                    <div className="content">
                                        <h4>Never Miss a Lead Again</h4>
                                        <p>Every inquiry syncs in real time, ensuring no missed opportunities — even during non-working hours.
                                        </p>
                                    </div>
                                </div>

                                <div className="item">
                                    <div className="num"><img src={Arrow} /></div>
                                    <div className="content">
                                        <h4> Faster Response, Higher Conversion (25%–40% Increase)
                                        </h4>
                                        <p>The system assists your sales team in responding instantly, improving customer experience and increasing sales chances.</p>
                                    </div>
                                </div>

                                <div className="item">
                                    <div className="num"><img src={Arrow} /></div>
                                    <div className="content">
                                        <h4>Organized & Transparent Sales Pipeline</h4>
                                        <p>Track every lead from inquiry to closure, improving accountability and reducing confusion among team members.</p>
                                    </div>
                                </div>

                                <div className="item">
                                    <div className="num"><img src={Arrow} /></div>
                                    <div className="content">
                                        <h4>Better Decision-Making with Accurate Data</h4>
                                        <p>Identify top-performing sources, team members, and campaigns with actionable reports.
                                        </p>
                                    </div>
                                </div>

                                <div className="item">
                                    <div className="num"><img src={Arrow} /></div>
                                    <div className="content">
                                        <h4>Enhanced Customer Experience</h4>
                                        <p>Consistent follow-ups, timely responses, and personalized communication help you build trust and close deals faster.</p>
                                    </div>
                                </div>
                            </section>

                            {/* Why Choose Us */}
                            <section className="why-choose attendance-choose">
                                <h3>Who Is This Ideal For?</h3>
                                <ul>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Traders</li>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Manufacturers</li>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Service Providers</li>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Exporters & B2B Companies</li>
                                </ul>
                            </section>

                            {/* CTA */}
                            <section className="cta-section attendance-p">
                                <h3>Collaborate with Us</h3>
                                <p>
                                    At Horizon Webinfo Pvt. Ltd. we blend innovation with deep business understanding to create tools that help you grow faster. Our Lead Management System adapts to your workflow and strengthens your sales funnel from day one.

                                </p>
                                <Link to="/get-a-quote" className="quote-btn1-brand">
                                    <span><i aria-hidden="true" class="fas fa-external-link-alt"></i> GET A QUOTE</span>
                                </Link>
                            </section>
                        </section>
                    </div>
                </div>
            </section>
        </div>
    );
}